import i from"styled-components";var e=i.section`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    width: 100%;
    gap: inherit;

    color: inherit;
    border-radius: inherit;
    isolation: isolate;
`;export{e as a};
//# sourceMappingURL=ninox-components-SEYOK2DK.js.map